const fetch = require('node-fetch');
const jwt_decode = require("jwt-decode");

//Set up default response
  const response = {
    statusCode: 500,
    body: "Not Implemented",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
      "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0",
      Pragma: "no-cache",
      Expires: "0"
    }
  };

export async function activateUser(event) {
  
  const token = event.headers["id-token"];
  const decodedToken = jwt_decode(token);

    if(!event.method)
    {
        event.method='GET';
    }
  
  // Get Educators for a centre
  if (event.method === "GET") {

    let endpoint = window.config.serverUrl + '/api/user-details/idm/' + decodedToken.detuserguid;

    await fetchJSON(endpoint).then(results => {
      response.body = results.resources;
      response.statusCode = 200;
    },err=>{
      console.log("fetchJSON ... "+err)
    });
  } else if (event.method === "POST") {
    const body = Object.assign({}, JSON.parse(event.body));

    Object.keys(body).forEach(key => {
      if (typeof body[key] === "string") {
        body[key] = body[key].trim();
      }
    });
    
    // Check if valid director
    if(decodedToken.acl.includes(`${body.seNumber} TTSDS Director`) ) {
      let schema;
      if(body.hasOwnProperty("userUsername")) {
        schema = {
          "schemas": [ "urn:ietf:params:scim:schemas:core:2.0:User", "urn:scim:my:custom:schema" ],
          "userName": "",
          "entitlements" : {},
          "selectedService": "",
          "active": true
        }
        schema.userName = body.userUsername;
      } else {
        schema = {
          "schemas" : [ "urn:ietf:params:scim:schemas:core:2.0:User", "urn:scim:my:custom:schema" ],
          "name" : {
            "familyName" : "",
            "givenName" : ""
          },
          "emails" : [],
          "phoneNumbers": [],
          "entitlements" : {},
          "selectedService": "",
          "active" : true,
          "urn:scim:my:custom:schema": {
            "dateOfBirth": ""
          }
        };
        const birthdate = await formatDate(body.userDateOfBirth);
        schema.name.familyName = body.userLastName;
        schema.name.givenName = body.userFirstName;
        schema.selectedService = "Educator";
        schema["urn:scim:my:custom:schema"].dateOfBirth = birthdate.scim;
        schema.emails.push({ primary: true, value: body.userEmail, type: "work" });
        if(body.hasOwnProperty("userMobile") && body.userMobile !== "") {
          schema.phoneNumbers.push({"value": body.userMobile, "type": "mobile"});  
        }
      }
      Object.assign(schema.entitlements, { [body.seNumber]: body.role });
  
      const url = window.config.serverUrl + '/api/user-details/idm';
      let tokenval = localStorage.getItem("id_token");

      let user = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'isportal': 'true',
          'ssotoken' : tokenval
        },
        body: JSON.stringify(schema)
      });

      const data = await user.json();

      if(user.status == 200) {
        response.body = JSON.stringify(user.message);
        response.statusCode = 200;
        return response;
      } else {
        response.statusCode = user.status;
        return response;
      }

    } else {
      response.statusCode = 403;
      response.body = {
        code: "InvalidSeNumber",
        message: "Invalid SE-Number and role."
      };
    }
    
  } else if (event.method === "PUT") {
    // Use the person's detuserid
    const detuserid = event.pathParameters.username;

    let schema = {
      "schemas" : [ "urn:ietf:params:scim:schemas:core:2.0:User", "urn:scim:my:custom:schema" ],
      "id": "",
      "name" : {
        "familyName" : "",
        "givenName" : ""
      },
      "emails" : [],
      "phoneNumbers": [],
      "entitlements" : {},
      "selectedService": "",
      "active" : true,
      "urn:scim:my:custom:schema": {
        "dateOfBirth": ""
      }
    };
    const body = Object.assign({}, JSON.parse(event.body));
    const birthdate = await formatDate(body.userDateOfBirth);
    schema.id = detuserid;
    schema.name.familyName = body.userLastName;
    schema.name.givenName = body.userFirstName;
    schema.selectedService = "Educator";
    schema["urn:scim:my:custom:schema"].dateOfBirth = birthdate.scim;
    schema.emails.push({ primary: true, value: body.userEmail, type: "work" });
    Object.assign(schema.entitlements, { [body.seNumber]: body.role });
    if(body.hasOwnProperty("userMobile") && body.userMobile !== "") {
      schema.phoneNumbers.push({"value": body.userMobile, "type": "mobile"});  
    }
    let tokenval = localStorage.getItem("id_token");

    const url = window.config.serverUrl + '/api/user-details';
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'isportal': 'true',
        'ssotoken' : tokenval,
        "X-API-Key": window.config.IDM_API_KEY
      },
      body: JSON.stringify(schema)
    };

    await fetchJSON(url, options).then(results => {
      response.body = JSON.stringify(results);
      response.statusCode = 200;
      //callback(null, response);
    });
  } else if (event.method === "PATCH") {

    let schema = [
      {
        "op": "",
        "path": "entitlements",
        "value": {}
      }
    ];
    const body = Object.assign({}, JSON.parse(event.body));
    
    // Use the person's detuserid
    const detuserguid = body.detUserGuid;
    
  // Check if valid director
    if(decodedToken.acl.includes(`${body.seNumber} TTSDS Director`) ) {
      
      schema[0].op = body.op;
      schema[0].value = { [body.seNumber]: body.role };
      let tokenval = localStorage.getItem("id_token");

      const url = window.config.serverUrl + '/api/user-details/idm/remove/' + detuserguid;
      const options = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          'isportal': 'true',
          'ssotoken' : tokenval
        },
        body: JSON.stringify(schema)
      };
  
      await fetchText(url, options).then(results => {
        response.body = JSON.stringify({ message: results });
        response.statusCode = 200;
        //callback(null, response);
      });
    } else {
      response.statusCode = 403;
      response.body = {
        code: "InvalidSeNumber",
        message: "Invalid SE-Number and role."
      };
      //callback(null, response);
    }
  }

    return response;
};

async function fetchJSON(url) {
  let users = [];
  
  let tokenval = localStorage.getItem("id_token");
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'isportal': 'true',
      'ssotoken' : tokenval,
      'Content-Type': 'application/json'
    }
  }, err=>{
    console.log(err)
  });

  const data = await response.json();
  console.log("data" + JSON.stringify(data))
  users.push(data);
 
  return data;
}

async function fetchText(url, options) {
  const response = await fetch(url, options);
  const results = await response.text();
  return results;
}

async function formatDate(timestamp) {
  const date = new Date(timestamp);
  const day = date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    day: "2-digit"
  });
  const month = date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    month: "2-digit"
  });
  const year = date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    year: "numeric"
  });
  return {
    timestamp: timestamp,
    date: date.toLocaleString("en-AU", { timeZone: "Australia/Sydney" }),
    day: day,
    month: month,
    year: year,
    full: `${day}/${month}/${year}`,
    scim: `${year}${month}${day}`,
    monthYear: `${month}/${year}`
  };
}
